import { Button, Stack } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const NewsletterSignup = () => {
    const handleClick = () => {
        window.open("https://buttondown.email/gautham_ram", "popupwindow");
    };

    return (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 4 }}>
            <MailOutlineIcon color="primary" />
            <Button variant="text" onClick={handleClick}>
                Subscribe
            </Button>
        </Stack>
    );
};

export default NewsletterSignup;
